export const PICO_TIMEZONE = "Europe/Prague";
